import * as React from "react";

const GridContext = React.createContext({
    gap: 0,
});

export default GridContext;
